'use strict';exports.__esModule = true;exports.incrementClicks = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var incrementClicks = (0, _reduxAct.createAction)('/INCREMENT_CLICKS');
var incrementClicksSuccess = (0, _reduxAct.createAction)('/INCREMENT_CLICKS_SUCCESS');
var incrementClicksFail = (0, _reduxAct.createAction)('/INCREMENT_CLICKS_FAIL');

var initialState = {
  loaded: false,
  loading: false,
  data: [] };


var fetchIncrementClicks = function fetchIncrementClicks(id) {return _axios2.default.put('/properties/' + id + '/increment_phone_clicks').
  then(incrementClicksSuccess, incrementClicksFail);};

var handleIncrementClicks = function handleIncrementClicks(state, _ref) {var id = _ref.id;return (
    (0, _reduxLoop.loop)(Object.assign({}, state, { loaded: false, loading: true }), promise(fetchIncrementClicks, id)));};

var handleSuccess = function handleSuccess(state) {return Object.assign({},
  state, {
    loading: false,
    loaded: true });};


var handleFail = function handleFail(state) {return Object.assign({},
  state, {
    loading: false,
    loaded: false });};


var incrementPhoneClicks = (0, _reduxAct.createReducer)(function (on) {
  on(incrementClicksSuccess, handleSuccess);
  on(incrementClicksFail, handleFail);
  on(incrementClicks, handleIncrementClicks);
}, initialState);exports.


incrementClicks = incrementClicks;exports.default =


incrementPhoneClicks;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/incrementPhoneClicks.js
// module id = 3091
// module chunks = 0